import {Component, ViewEncapsulation, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {SelfAttendanceService} from "../../../shared/services/self-attendance.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PaymentMethodOption} from "../../../shared/model/payment-method-option";
import {SelfAttendanceData} from "../../../shared/model/self-attendance-data";
import {Dtm, getDtm} from "../../../shared/enum/dtm";
import {SYDLEClientID} from "../../../shared/constants/one-constants";
import {SessionStorageService} from "../../../shared/services/session-storage.service";
import {DtmService} from "../../../services/dtm.service";
import {ShopWindowItem} from "../../../shared/model/shop-window-item";
import {environment} from "../../../../environments/environment";
import {PaymentFormComponent} from "../../../shared/components/payment-form/payment-form.component";
import {braspagReasonCode, errorMapping, adyenReasonCode} from "../../../shared/constants/errors";
import { LoadingService } from 'src/app/shared/services/loading.service';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { CreditCardData } from 'src/app/shared/model/credit-card-data';

@Component({
    selector: 'pme-self-attendance-auto-recharge-payment',
    templateUrl: './auto-recharge-payment.component.html',
    styleUrls: ['./auto-recharge-payment.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class SelfAttendanceAutoRechargePaymentComponent implements OnInit, AfterViewInit {


  @ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;
  @ViewChild(PaymentFormComponent) paymentAdyenForm: PaymentFormComponent;

  // Hero Inicial
  heroData: any;

  currentPaymentMethod: string;
  showForm: boolean;
  classificationIdentifier: string;

  selfAttendanceData: SelfAttendanceData;
  selectedPackage: ShopWindowItem;

  paymentOptions: Array<PaymentMethodOption>;
  buttonName: string = 'Ativar recarga garantida';
  redirectUrl: string = environment.serasaHomePage;
  context: string;
  sameCard: boolean;
  automaticRecharge: string;
  paymentErrors: Array<string> = [];

  // SessionStorage Variables ( REMOVER DEFAULT )
  userId: string;
  businessId: string;

  showErrorHero: boolean = false;
  shopWindowLink: string;

  creditCardsData: CreditCardData[];
  maxLimitCreditCards: boolean;
  creditCardData: CreditCardData;

  tdu: string;

  constructor(
    private selfAttendanceService: SelfAttendanceService,
    private route: ActivatedRoute,
    private router: Router,
    public dtmService: DtmService,
    public sessionStorageService: SessionStorageService,
    private loading: LoadingService,
    private breadcrumbService: BreadcrumbService
  ) {

    if (!this.selfAttendanceService.getCurrentSelfAttendanceData()) {
      this.selfAttendanceService.getSelfAttendanceDataFromSessionStorage();
    }

    this.classificationIdentifier = this.sessionStorageService.getClassification(route);
    if(this.selfAttendanceService.getCurrentSelfAttendanceData()) {

      this.selfAttendanceData = this.selfAttendanceService.getCurrentSelfAttendanceData();
      this.selectedPackage = this.selfAttendanceData.selectedPackage;
      this.paymentOptions = this.selectedPackage.paymentMethods;

      let automaticRechargeValue = this.selectedPackage.product.automaticRecharge;
      this.automaticRecharge = Number.isInteger(automaticRechargeValue) ? automaticRechargeValue.toString() : automaticRechargeValue.toFixed(2).replace('.',',').toString();

      this.tdu = this.selectedPackage.tdu;

      this.dtmService.productsLoaded([{
        identifier: this.selectedPackage.product.identifier,
        classificationName: this.selectedPackage.product.classificationName
      }]);

      this.dtmService.pageLoaded(Dtm.AtivarRecargaPagamento, true, getDtm(Dtm.AtivarRecargaPagamento, this.classificationIdentifier));

      if (
        this.selfAttendanceData &&
        this.selfAttendanceData.account
      ) {
        this.userId = this.selfAttendanceData.account.userId;
        this.businessId = this.selfAttendanceData.account.businessId;

        this.selfAttendanceService.getStoredCreditCard(this.userId, this.businessId).subscribe(
          (creditCardData) => {
            this.selfAttendanceData.creditCardData = creditCardData;
            this.sameCard = true;
        });
        this.dtmService.userLoaded({
          businessId: this.selfAttendanceData.account.businessId,
          userId: this.selfAttendanceData.account.userId,
          cliendId: SYDLEClientID,
        });
      }

      this.redirectUrl = this.selfAttendanceService.redirectURL || this.redirectUrl;
      this.shopWindowLink = window.location.origin + '/auto-atendimento/consulta-e-recuperacao-de-dividas/alterar-recarga-garantida?userId=' + this.userId + '&businessId=' + this.businessId;


    }

    selfAttendanceService.getStoredCreditCards(this.userId, this.businessId, null).subscribe(results => {
      this.creditCardsData = results[0].length ? results[0] : null;
      this.maxLimitCreditCards = results[1];
    });
  }

  ngAfterViewInit(): void {
    this.loading.finishTask();
  }

  ngOnInit() {
    let rechargeFormated = Number.isNaN(Number(this.automaticRecharge)) ? this.automaticRecharge : Number(this.automaticRecharge).toFixed(2).replace('.',',');
    this.heroData = {
      type: 'info',
      title: 'Ativar recarga garantida',
      contents: ['Quando seu crédito for igual ou menor que R$ ' + rechargeFormated + ', será feita uma nova recarga no valor do pacote escolhido sem desconto aplicado.']
    };



    this.dtmService.customLoaded(["AddToCart", "Checkout"], 'Sydle-ativar-recarga');

    this.currentPaymentMethod = this.paymentOptions[0].identifier;

    this.showForm = true;
    this.dtmService.sendPageLoadEvent();
  }

  onSubmit(paymentData: any) {
    this.dtmService.customClickEvent(this.buttonName);

    let requestData: any = {};
    requestData.paymentMethodIdentifier = paymentData.identifier;

    requestData.businessId = this.businessId;
    requestData.userId = this.userId;
    requestData.productId = this.selectedPackage.product._id;
    requestData.action = 'ACTIVATE';

    requestData.cardNumber = this.maskCreditCardNumber(paymentData.card.cardNumber);
    requestData.cardHolder = paymentData.card.cardHolder;
    requestData.cardBrand = paymentData.card.brand;

    requestData.defaultCard = paymentData.defaultCard;
    requestData.saveCard = paymentData.saveCard;
    requestData.nickname = paymentData.nickname;
    requestData.accountPaymentDataId = paymentData.accountPaymentDataId;

    if(paymentData.isAdyen) {
      requestData.encryptedCardNumber = paymentData.card.encryptedCardNumber;
      requestData.encryptedCardSecurityCode = paymentData.card.encryptedCardSecurityCode;
      requestData.encryptedCardValidityMonth = paymentData.card.encryptedCardValidityMonth;
      requestData.encryptedCardValidityYear = paymentData.card.encryptedCardValidityYear;
      requestData.isAdyen = true;
    } else {
      requestData.expirationMonth = this.getExpirationMonth(paymentData.card.cardValidityDate);
      requestData.expirationYear = this.getExpirationYear(paymentData.card.cardValidityDate);
      requestData.paymentToken = "";
    }

    requestData.sameCard = this.sameCard && !requestData.cardHolder ? true : false;
    requestData.classificationIdentifier = this.classificationIdentifier;
    requestData.paymentConditionIdentifier = paymentData.paymentConditionIdentifier;

    this.selfAttendanceService.activateAutomaticRecharge(requestData).subscribe(
      (selfAttendendanceData) => {
        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendendanceData);
        this.selfAttendanceService.redirectURL = this.redirectUrl;
        if (selfAttendendanceData.errorRFB) {
          this.paymentForm.addValidationError(errorMapping['mitigationMessageError']);
          // Analytics
          this.dtmService.customErrorLoaded(["error"], {
            errorDetail: '',
            errorMessage: errorMapping['mitigationMessageError'],
          });
          if (this.paymentForm) {
            this.paymentForm.submitting = false;
            this.paymentForm.disableSubmit = true;
          }
        } else {
          this.router.navigate(['../../sucesso'], {relativeTo: this.route});
        }
      }, (error) => {
        this.showCustomError('paymentChangeError', error);
      }
    )
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {

      case 'paymentChangeError':
        integrationErrorMessage = this.handlePaymentChange(integrationError);

        console.error(integrationErrorMessage);

        this.paymentForm.addValidationError(integrationErrorMessage.userMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      default:
        break;
    }
    if (this.paymentForm) {
      this.paymentForm.submitting = false;
      this.paymentForm.enableFields('all');
    }
  }

  maskCreditCardNumber(cardNumber: string): string {
    const unmaskedValue = cardNumber.substr(cardNumber.length - 4, 4);
    let maskedValue = cardNumber.substr(0, cardNumber.length - 4);
    maskedValue = maskedValue.split(' ').map(
      digitGroup => {
        let maskedGroup = '';
        while (maskedGroup.length < digitGroup.length) {
          maskedGroup += '*';
        }
        return maskedGroup;
      }
    ).join(' ');
    return maskedValue + unmaskedValue;
  }

  getExpirationMonth(expirationDate) {
    if (expirationDate) {
      let expirationMonth = expirationDate.split("/")[0];
      if (expirationMonth.length === 1) {
        return '0' + expirationMonth;
      } else {
        return expirationMonth;
      }
    } else {
      return '';
    }
  }

  getExpirationYear(expirationDate) {
    if (expirationDate) {
      let expirationYear = expirationDate.split("/")[1];
      return "20" + expirationYear;
    } else {
      return '';
    }
  }

  handlePaymentChange(error: any): any {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        resultError.userMessage = error.error._messages[0].text;

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if(adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (resultError.userMessage.indexOf('java') >= 0 ||
          resultError.userMessage.indexOf('Java') >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf('elastic') >= 0 ||
          resultError.userMessage.indexOf('Elastic') >= 0) {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        }
      }
    } catch (e) {

    }

    return resultError;
  }

  returnPage() {
    window.location.href = this.redirectUrl;
  }

  handleDeleteCreditCard(accountPaymentDataId: string): void {
    this.selfAttendanceService.removeCreditCard(this.userId, this.businessId, accountPaymentDataId)
      .subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];
      });
  }
}

